import { AnalyticsFeatureBrowserModule } from '@analytics/feature';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [AnalyticsFeatureBrowserModule],
})
export class AnalyticsShellBrowserModule {}
